<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'Post_level_management'"
      :addBtnList="listmenu"
      :hideAddBtn="!hasBtn('add-job-position-level')"
      :headers="headers"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['hierarchyName', 'org_level_uuid']"
      :items="desserts"
    >
      <template v-slot:btns>
        <!-- v-btnAuth="['import-post-grade']" -->
        <!-- <v-btn small
               tag="a"
               depressed
               height="40"
               v-btnAuth="['download-job-position-level-template']"
               :href="uploadUrl"
               rounded
               class="ml-4 white--text text-button"
               color="primary">
          {{ $t('label_Download_the_template') }}
        </v-btn> -->
        <mrc_ess_uploadBtn
          type="3"
          class="ml-4"
          :hrefUrl="uploadUrl"
          v-btnAuth="['import-job-position-level']"
          :label="$t('label_Batch_Import')"
        >
        </mrc_ess_uploadBtn>
      </template>
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <!-- 层级名称 -->
      <template v-slot:item.hierarchyName="{ item }">
        <div>
          <div v-if="INT(item.group_name)" class="text-caption text--secondary">
            {{ INT(item.group_name) }}
          </div>
          <div class="text-body-s">{{ INT(item.job_grade_name) }}</div>
        </div>
      </template>

      <!-- 使用单位 -->
      <template v-slot:item.org_level_uuid="{ item }">
        <mrc_ess_chip
          class="ma-1"
          small
          v-for="(item1, index1) in splitINT(INT(item.org_level_uuid))"
          :key="index1"
        >
          {{ item1 }}
        </mrc_ess_chip>
      </template>
      <!-- 按钮 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon>mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import {
  get_postgrades,
  delete_postgrades,
  delete_postgrades_group,
} from "@/service/api/postgrades.js";
import { JOB_LEVEL_URL } from "@/utils/constant/index.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      uploadUrl: "",
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    this.uploadUrl = JOB_LEVEL_URL;
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getlist();
  },
  beforeDestroy() {
    this.$store.commit("set_uuid2", "");
  },
  methods: {
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage;
      this.options.pagesize = pagesize;
      this.getlist();
    },
    async getlist(obj) {
      //获取岗位列表
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const org_level_uuid = this.$store.state.currentCompany;
      const res = await get_postgrades({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        org_level_uuid,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.desserts = res.data;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
        // this.desserts = res.data.map(item => {
        //   // item.org_level_uuid = '后端,还未返回,这个,字段'   //后端未改接口 前端自己添加
        //   // item.org_level_uuid = (item.org_level_uuid.indexOf(',') != -1) ? item.org_level_uuid.split(',') : [item.org_level_uuid];
        //   return item
        // })
      }
      this.loading = false;
    },
    godetail(item) {
      //行内进编辑详情页
      this.$store.commit("set_uuid", item.uuid);
      this.$store.commit("set_uuid2", String(item.staff_number)); //使用中岗位数目
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      item.group_name
        ? this.$store.commit("set_group_name", item.group_name)
        : "";
      item.job_grade_name
        ? this.$store.commit("set_subPage_name", item.job_grade_name)
        : "";
      this.$router.push({
        name: "detailPost",
        params: {
          uuid: item.uuid,
          iconstatus: true,
        },
      });
    },
    // 编辑
    editPrompt(item) {
      //详情页
      this.$store.commit("set_uuid2", String(item.staff_number)); //使用中岗位数目
      this.$store.commit("set_uuid", item.uuid);
      this.$store.commit("set_iconstatus", false); //行内进图标显示
      item.group_name
        ? this.$store.commit("set_group_name", item.group_name)
        : "";
      item.job_grade_name
        ? this.$store.commit("set_subPage_name", item.job_grade_name)
        : "";
      this.$router.push({
        name: "detailPost",
        params: {
          uuid: item.uuid,
          iconstatus: false,
        },
      });
    },
    // 删除
    handleDel(item) {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(() => {
          if (item.group_name) {
            delete_postgrades_group({
              group_name: item.group_name,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1 && this.options.cpage != 1)
                  this.options.cpage--;
                this.getlist();
              }
            });
          } else {
            delete_postgrades({
              uuid: item.uuid,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1 && this.options.cpage != 1)
                  this.options.cpage--;
                this.getlist();
              }
            });
          }
        })
        .catch(() => {});
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.editPrompt(obj);
          break;
        case "del":
          this.handleDel(obj);
          break;
      }
    },
  },
  computed: {
    listmenu() {
      return [
        {
          page_name: "addOne",
          name: this.$t("label_Add_a_single_level"),
          show: true,
        },
        {
          page_name: "addGroup",
          name: this.$t("label_A_set_of_new"),
          show: true,
        },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-job-position-level"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-job-position-level"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-job-position-level"),
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("label_The_name_of_the_hierarchy"),
          align: "start",
          sortable: false,
          value: "hierarchyName",
        },
        {
          text: this.$t("label_The_hierarchy"),
          align: "start",
          sortable: false,
          value: "job_grade_class",
        },
        {
          text: this.$t("label_Use_the_unit"),
          align: "start",
          sortable: false,
          value: "org_level_uuid",
        },
        {
          text: this.$t("label_Number_of_posts_in_use"),
          align: "start",
          sortable: false,
          value: "staff_number",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ];
    },
  },
  watch: {
    $route(v) {
      if (this.$route.name == "Post_level_management") {
        // console.log('更新list');
        this.getlist();
      }
    },
  },
};
</script>

<style scoped></style>
